import { PageBase } from "Pages/PageBase";
import React from "react";
import { render } from "react-dom";
import { PortalNavOnLegacy } from "./PortalNavOnLegacy";

export function initPortalMenu() {
   const portalMenuRoot = document.getElementById("portal-menu");
   if (portalMenuRoot) {
      const selectedPageName = portalMenuRoot.dataset["page"] || undefined;
      const footers = document.getElementsByTagName("footer");
      render(<PageBase>
         <PortalNavOnLegacy selectedPageName={selectedPageName} wrapper={portalMenuRoot} footer={footers.length > 0 ? footers[0] : undefined} />
      </PageBase>, portalMenuRoot);
   }
}
